export default __webpack_public_path__ + "static/media/corvello.e26295c3.jpg";